/** Ambiente de despliegue: staging = pruebas (npm run serve:staging / build:staging). */
export function esAmbienteStaging () {
  return process.env.VUE_APP_ENV === 'staging'
}

export const etiquetaAmbiente = 'Ambiente de pruebas'
